import React, { useState, useContext, useEffect } from 'react';
import { CloudUpload, EventAvailable } from '@mui/icons-material';
import { Grid, Typography, Button, Divider, Box, Alert } from '@mui/material';
import { makeStyles, useTheme } from '@mui/styles';
import { Calificacion, Lectura, Video, Examen, MaterialDescargable } from 'views/HomeParticipantes/ComponentsHomeVentas';
import FormEvidencia from './FormEvidencia';
import { VisorPDF } from 'ui-component';
import LayautContext from 'Context/ContextLayaut';
import Services from '../Components/services';
import Imagen from './Imagen';
import ActPdf from './ActPdf';
import Audio from 'views/HomeParticipantes/ComponentsHomeVentas/Audio';
import Enlace from './Enlace';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
    curso: {
        backgroundColor: theme.palette.secondary[800]
    },
    grupo: {
        borderRadius: '8px',
        color: theme.palette.primary.light,
        backgroundColor: theme.palette.secondary[800]
    }
}));

const Actividad = (props) => {
    const { breadcrumbs, data, regresar } = props;
    const services = Services();
    const context = useContext(LayautContext);
    const classes = useStyles();
    const theme = useTheme();

    const periodoFinalizado = Boolean(data?.infoGeneral?.periodoFinalizado ?? data?.periodoFinalizado);
    const periodoActivo = Boolean(data?.infoGeneral?.periodoActivo ?? data?.periodoActivo);
    const fechaFinPeriodo = data?.infoGeneral?.fechaFinPeriodo ?? data?.fechaFinPeriodo;
    const tienePeriodo = Boolean(fechaFinPeriodo);

    //  MOSTRAR AVISO SOLO CUANDO EL PERIODO ESTA VIGENTE
    const mostrarAvisoVigencia = tienePeriodo && periodoActivo && !periodoFinalizado;

    const abrirFormEvidencia = (data) => {
        context.formulario.abrir({
            open: true,
            width: 'sm',
            titulo: 'Evidencia de material ' + data.titulo,
            btnAceptarName: 'Guardar',
            propsForm: { data: { ...data?.infoGeneral, idColaborador: data?.idColaborador } || {} },
            formulario: FormEvidencia,
            aceptar: subirEvidencia(data)
        });
    };

    const subirEvidencia = (data) => (dataForm) => {
        const dataFormPivote = { ...dataForm };
        const formData = new FormData();
        const servicioRespuestaActividad = dataForm.esUpdate
            ? services.updateRespuestaActividadEntregable
            : services.insertRespuestaActividadEntregable;

        if (dataForm.archivo && dataForm?.archivo?.length > 0) dataFormPivote.archivo = dataForm.archivo[0].file;
        else return context.formulario.cerrar();

        formData.append('idDetalleActividad', data.idDetalleActividad);
        formData.append('idColaborador', data.idColaborador);
        formData.append('idActividad', data.idActividad);
        formData.append('idTemario', data.idTemario);
        formData.append('idSesion', data.idSesion);
        formData.append('idCurso', data.idCurso);
        formData.append('idTipoActividad', data.infoGeneral.idTipoActividad);

        if (dataFormPivote?.archivo?.size > 1900000) {
            const nombreOriginal = dataFormPivote.archivo.path || dataFormPivote.archivo.name;
            formData.delete('archivo');
            context.formulario.cerrar();

            services.chunkFile(
                (res, uidFolderName) => {
                    formData.append('archivo', uidFolderName + '/' + nombreOriginal);
                    formData.append('uidFolderName', uidFolderName);
                    servicioRespuestaActividad(
                        (res) => {
                            context.mensaje({ open: false });
                        },
                        formData,
                        {
                            cargando: true,
                            isBigFileResponse: true,
                            uidFolderName: uidFolderName,
                            hideSuccessMessage: true
                        }
                    );
                },
                {},
                dataFormPivote.archivo
            );
        } else {
            formData.append('archivo', dataFormPivote.archivo);
            servicioRespuestaActividad(
                (res) => {
                    context.formulario.cerrar();
                },
                formData,
                {
                    headers: {
                        'content-type': 'multipart/form-data'
                    }
                }
            );
        }
    };

    const buscaEsIncognito = (datos) => {
        // if (datos) {
        //     if (
        //         datos.descargable != false ||
        //         datos.examen != false ||
        //         datos.imagen != false ||
        //         datos.lectura != false ||
        //         datos.pdf != false ||
        //         datos.video != false
        //     ) {
        //         return true;
        //     } else {
        //         return false;
        //     }
        // } else {
        //     return false;
        // }
        if (datos && datos == true) {
            return true;
        } else {
            return false;
        }
    };

    // useEffect(() => {
    //     if (data) {
    //         console.log('llega actividad', data);
    //     }
    // }, [data]);
    return (
        <Grid sx={{ backgroundColor: '#ccbe95', borderRadius: '10px', padding: '2px' }} container spacing={2}>
            {/* <Grid item xs={12}>
                <Breadcrumbs aria-label="breadcrumb">
                    <StyledBreadcrumb label="Inicio" icon={<Bookmark fontSize="small" />} onClick={() => regresar()} />
                    {arrBradcrumbs.map((bread, key) => {
                        const crumb = bread?.split('^~');
                        const id = crumb[0];
                        const titulo = crumb[1];

                        // Necesita los prefijos para saber el id seleccionado
                        return key < 4 ? (
                            <StyledBreadcrumb
                                key={`${id}-${titulo}`}
                                label={titulo}
                                icon={<Bookmark fontSize="small" />}
                                onClick={() => collapse[key](`${prefix[key]}${id}`)}
                            />
                        ) : (
                            <StyledBreadcrumb key={`${id}-${titulo}`} label={titulo} icon={<Star fontSize="small" />} />
                        );
                    })}
                </Breadcrumbs>
            </Grid> */}
            <Grid sx={{ backgroundColor: '#ccbe95' }} item xs={6}>
                <Box sx={{ ml: 2 }}>
                    <Typography variant="menuHeader" sx={{ color: '#FFFFFF' }}>
                        {data?.titulo}
                    </Typography>
                </Box>
            </Grid>
            {Number(data?.infoGeneral?.esEntregable) &&
                data?.infoGeneral?.solicitarEvidencia == 1 &&
                !buscaEsIncognito(props.esIncognito) == true &&
                !periodoFinalizado && (
                    <Grid sx={{ backgroundColor: '#ccbe95' }} xs={6} justifyContent="flex-end">
                        <Button
                            id="btn-evid"
                            component="label"
                            role={undefined}
                            variant="contained"
                            tabIndex={-1}
                            startIcon={<CloudUpload />}
                            color="success"
                            onClick={() => abrirFormEvidencia(data)}
                            style={{ marginBottom: '10px', marginTop: '10px' }}
                        >
                            Subir evidencia
                        </Button>
                    </Grid>
                )}
            <Grid item xs={12}>
                <Divider variant="fullWidth" sx={{ borderColor: '#a09e99' }} />
            </Grid>

            {mostrarAvisoVigencia && (
                <Grid item xs={12} sx={{ px: 2, mt: 1 }}>
                    <Alert
                        icon={<EventAvailable fontSize="inherit" />}
                        severity="info"
                        variant="outlined"
                        sx={{
                            backgroundColor: 'rgba(255,255,255,0.6)',
                            borderColor: '#003764',
                            color: '#003764',
                            '& .MuiAlert-icon': { color: '#003764' }
                        }}
                    >
                        Disponible hasta {moment(fechaFinPeriodo).format('DD/MM/YYYY [a las] hh:mm A')}
                    </Alert>
                </Grid>
            )}

            <Grid sx={{ m: 2 }} item xs={12}>
                <Box>
                    {data?.idCalificacionDetalle &&
                        data?.idCalificacionDetalle != null &&
                        [3, 7, 10, 11, 12].includes(Number(data?.infoGeneral?.idTipoActividad)) && <Calificacion {...props} />}

                    {data?.lectura && <Lectura {...props} soloLectura={periodoFinalizado} />}
                    {data?.video && <Video {...props} soloLectura={periodoFinalizado} />}
                    {data?.examen && (!data?.idCalificacionDetalle || data?.idCalificacionDetalle == null) && (
                        <Examen {...props} soloLectura={periodoFinalizado} />
                    )}
                    {data?.encuesta && (!data?.idCalificacionDetalle || data?.idCalificacionDetalle == null) && (
                        <Examen {...props} soloLectura={periodoFinalizado} />
                    )}
                    {data?.examen_completo && (!data?.idCalificacionDetalle || data?.idCalificacionDetalle == null) && (
                        <Examen {...props} soloLectura={periodoFinalizado} />
                    )}
                    {data?.pdf && <ActPdf {...props} soloLectura={periodoFinalizado} />}
                    {data?.imagen && <Imagen {...props} soloLectura={periodoFinalizado} />}
                    {data?.descargable && <MaterialDescargable {...props} soloLectura={periodoFinalizado} />}
                    {data?.audio && <Audio {...props} soloLectura={periodoFinalizado} />}
                    {data?.enlace && <Enlace {...props} soloLectura={periodoFinalizado} />}
                    {data?.encuesta_completa && (!data?.idCalificacionDetalle || data?.idCalificacionDetalle == null) && (
                        <Examen {...props} soloLectura={periodoFinalizado} />
                    )}
                </Box>
            </Grid>
        </Grid>
    );
};

export default Actividad;
